/*
  Theme stored script asset for extra functionalities on product grids.
  Product grid video controls
  Product grid filter interactivity
  Product grid alternative media handling
  Ajaxinate endless scroll
*/
// Product grid video controls custom element
if(!customElements.get('product-grid-video')) {
  class ProductGridVideo extends HTMLElement {
    constructor() {
      super();
      this.elements = null;
      this.player = null;
    }

    connectedCallback() {
      this.elements = this.setVideoElements();
      if (!this.elements) return;
      this.player = new Vimeo.Player(this.elements.iframe);
      this.setEventListeners();
    }

    setVideoElements() {
      const elements = {
        playButton: this.querySelector('.plp__view-video'),
        closeButton: this.querySelector('.plp__video-close'),
        iframe: this.querySelector('.plp__video'),
        mobileWrapper: this.querySelector('.mobile-video-wrapper'),
        cardInner: this.closest('.card__inner'),
        cardMedia: this.closest('.card__inner')?.querySelector('.card__media')
      };

      if (!elements.playButton || !elements.closeButton) return null;

      return elements;
    }

    setEventListeners() {
      this.elements.playButton.addEventListener('click', () => {
        this.play();
      });

      this.elements.closeButton.addEventListener('click', () => {
        this.close();
      });

      // Handle video state changes
      this.player.on('play', () => this.setPlayingState());
      this.player.on('pause', () => this.setPausedState());
      this.player.on('ended', () => this.close());
    }

    setPlayingState() {
      this.classList.add('active');
      this.classList.remove('paused');
    }

    setPausedState() {
      this.classList.add('paused');
    }

    clearStates() {
      this.classList.remove('active', 'paused');
    }

    play() {
      const {
        iframe,
        closeButton,
        mobileWrapper,
        playButton,
        cardInner,
        cardMedia
      } = this.elements;

      this.player.play();

      // Show video elements
      [iframe, closeButton, mobileWrapper].forEach(el => el.classList.add('shown'));

      // Adjust visual states
      playButton.style.opacity = '0.25';
      if (cardInner) cardInner.classList.add('background_white');
      if (cardMedia) cardMedia.style.opacity = '0.25';
    }

    close() {
      const {
        iframe,
        closeButton,
        mobileWrapper,
        playButton,
        cardInner,
        cardMedia
      } = this.elements;

      this.player.pause();

      // Hide video elements
      [iframe, closeButton, mobileWrapper].forEach(el => el.classList.remove('shown'));

      // Reset visual states
      playButton.style.opacity = '1';
      if (cardInner) cardInner.classList.remove('background_white');
      if (cardMedia) cardMedia.style.opacity = '1';

      // Clear state classes
      this.clearStates();
    }

    disconnectedCallback() {
      if (this.player) {
        this.player.destroy();
      }
    }
  }

  customElements.define('product-grid-video', ProductGridVideo);
}

// Various product grid code enhancements, wrap it all to avoid leaks at the global scope
(()=>{
  // Elements
  const filterWrapper = document.getElementById('FacetsWrapperDesktop1');
  const filterButton = document.getElementById('js-filter');
  const filterCloseButton = document.getElementById('js-filter-close');
  const sortWrapper = document.getElementById('sw-wrap');
  const sortButton = document.getElementById('js-sort-open');
  const viewButton = document.getElementById('js-view-open');
  
  const viewOnModelButton = document.getElementById('on_model');
  const viewInEditorialButton = document.getElementById('in_editorial');
  const viewGalleryButton = document.getElementById('view_gallery');
  
  const viewOptionsBox = document.getElementById('view-detail-box');

  filterButton?.addEventListener("click", (event) => {
    event.preventDefault();
    filterWrapper && filterWrapper.classList.add("open");
  });

  filterCloseButton?.addEventListener("click", (event) => {
    event.preventDefault();
    filterWrapper && filterWrapper.classList.remove("open");
  });

  sortButton?.addEventListener("click", (event) => {
    event.preventDefault();
    sortWrapper && sortWrapper.classList.add("open");
  });

  //Sort Button Hover
  sortButton?.addEventListener('mouseenter', (event) => {
    filterButton && filterButton.classList.add('js-filter-after');
  });

  sortButton?.addEventListener('mouseleave', (event) => {
    filterButton && filterButton.classList.remove('js-filter-after');
  });

  //View Button Hover
  viewButton?.addEventListener('mouseenter', (event) => {
    sortButton && sortButton.classList.add('js-sort-after');
  });

  viewButton?.addEventListener('mouseleave', (event) => {
    sortButton && sortButton.classList.remove('js-sort-after');
  });

  //View JS
  viewButton?.addEventListener('click', (event) => {
    viewOptionsBox && viewOptionsBox.classList.toggle('open');
  });

  const clearActiveViewOptions = () => {
    viewOnModelButton?.classList.remove('active');
    viewGalleryButton?.classList.remove('active');
    viewInEditorialButton?.classList.remove('active');
    
    viewOptionsBox?.querySelectorAll('li.active').forEach((list) => {
      list.classList.remove('active');
    });
  }

  //On Model JS
  viewOnModelButton?.addEventListener('click', (event) => {
    // clear the active state from each view option.
    clearActiveViewOptions();
    viewOnModelButton.classList.toggle('active');
    if(viewOptionsBox?.classList.contains('open')){
      viewOptionsBox.classList.remove('open');
    }
    // evaluate the grid items that have on model images
    let gridItemsWithOnModelImages = document.querySelectorAll('li.grid__item:has(.on_model_images)');
    gridItemsWithOnModelImages?.forEach((gridItem) => {
      const onModelImages = gridItem.querySelector('.on_model_images');
      onModelImages && onModelImages.classList.add('on_model_images_show');
      const inEditorialImages = gridItem.querySelector('.in_editorial_images');
      inEditorialImages && inEditorialImages.classList.add('in_editorial_images_hide');
      const plpImage = gridItem.querySelector('.plp_image');
      plpImage && plpImage.classList.add('plp_images_hide');
    });
  });

  // In Editorial JS
    viewInEditorialButton?.addEventListener('click', (event) => {
    // clear the active state from each view option.
      clearActiveViewOptions();
      viewInEditorialButton.classList.toggle('active');
      if (viewOptionsBox?.classList.contains('open')) {
        viewOptionsBox.classList.remove('open');
      }
    
      // First, hide other special image types
      let gridItemsWithOnModelImages = document.querySelectorAll('li.grid__item:has(.on_model_images_show)');
      gridItemsWithOnModelImages.forEach((gridItem) => {
        gridItem.querySelector('.on_model_images')?.classList.remove('on_model_images_show');
        gridItem.querySelector('.in_editorial_images')?.classList.remove('in_editorial_images_hide');
        gridItem.querySelector('.plp_image')?.classList.remove('plp_images_hide');
      });
    
      let gridItemsWithEditorialImages = document.querySelectorAll('li.grid__item:has(.in_editorial_images)');
      gridItemsWithEditorialImages.forEach((gridItem) => {
        gridItem.querySelector('.in_editorial_images')?.classList.add('in_editorial_images_show');
        gridItem.querySelector('.on_model_images')?.classList.add('on_model_images_hide');
        gridItem.querySelector('.plp_image')?.classList.add('plp_images_hide');
      });
    });

    // Inside viewGalleryButton.addEventListener...
    let gridItemsWithEditorialImages = document.querySelectorAll('li.grid__item:has(.in_editorial_images_show)');
    gridItemsWithEditorialImages.forEach((gridItem) => {
      gridItem.querySelector('.in_editorial_images')?.classList.remove('in_editorial_images_show');
      gridItem.querySelector('.plp_image')?.classList.remove('plp_images_hide');
    });

  //Gallery JS
  viewGalleryButton?.addEventListener('click', (event) => {
    // clear the active state from each view option.
    clearActiveViewOptions();
    // set the clicked view option to active.
    viewGalleryButton.classList.toggle('active');
    // clear the open class from the parent node
    if(viewOptionsBox?.classList.contains('open')){
      viewOptionsBox.classList.remove('open');
    }
    // evaluate the grid items with active on model images, and clear them
    let gridItemsWithActiveOnModelImages = document.querySelectorAll('li.grid__item:has(.on_model_images_show)');
    gridItemsWithActiveOnModelImages.forEach((gridItem) => {
      // if we have an onModel image, hide it.
      const onModelImages = gridItem.querySelector('.on_model_images');
      onModelImages && onModelImages.classList.remove('on_model_images_show');
      // find the base plp image, and remove the hide class.
      const plpImage = gridItem.querySelector('.plp_image');
      plpImage && plpImage.classList.remove('plp_images_hide');
    });

    // evaluate the grid items with active in editorial images, and clear them
    let gridItemsWithActiveInEditorialImages = document.querySelectorAll('li.grid__item:has(.in_editorial_images_show)');
    gridItemsWithActiveInEditorialImages.forEach((gridItem) => {
      // if we have an inEditorial image, hide it.
      const inEditorialImages = gridItem.querySelector('.in_editorial_images');
      inEditorialImages && inEditorialImages.classList.remove('in_editorial_images_show');
      // find the base plp image, and remove the hide class.
      const plpImage = gridItem.querySelector('.plp_image');
      plpImage && plpImage.classList.remove('plp_images_hide');
    });
    
  });



  // START: Mobile filter accordions
  const filterTitles = document.querySelectorAll(".Filter__title");
  filterTitles?.forEach((title) => {
    title.addEventListener("click", toggleAccordion(title));
  });

  function toggleAccordion(title) {
    if(!title) return;
    title.addEventListener("click", (event) => {
      if (title.parentNode.classList.contains("open")) {
        title.parentNode.classList.remove("open");
      } else {
        for (var filterTitle of filterTitles) {
          filterTitle.parentNode.classList.remove("open");
        }
        title.parentNode.classList.add("open");
      }
    });
  }
  // END: Mobile fitler accordions

  // I don't quite get the purpose of this function
  document.addEventListener('mouseup', (event) => {
    const containers = document.querySelectorAll('.js-filter-wrapper');
    containers?.forEach((container) => {
      if(container.contains(event.target)) return;
      container.classList.remove("open");
    });
  });

  // I don't quite ge the purpose of this function
  document.addEventListener('mouseup', (event) => {
    const containers = document.querySelectorAll('.js-sort-wrapper');
    containers?.forEach((container) => {
      if(container.contains(event.target)) return;
      container.classList.remove("open");
    });
  });

  // Close video elements if clicking outside the grid
  document.addEventListener('click', (event) => {
    const productGridWithPlayingVideos = document.querySelector('.product-grid-container:has(product-grid-video.active)');
    // no product grid on the page? early exit.
    if(!productGridWithPlayingVideos) return;
    // if we clicked an element inside the grid, let the videos do their thing.
    if(productGridWithPlayingVideos.contains(event.target)) return;
    const activeVideos = document.querySelectorAll('.product-grid-container product-grid-video.active');
    activeVideos.forEach(activeVideo => {
      activeVideo.close();
    });
  });

  const gridbuttons = document.querySelectorAll(".Collection__grid-button");
  gridbuttons?.forEach((gridbutton) => {
    gridbutton.addEventListener("click", (event) => {
      if (!event.target.classList.contains("Collection__grid-button")) return;
      event.preventDefault();
      let nextElement = null;
      if (event.target.classList.contains("Collection__grid-button-left")) {
        nextElement = event.target.nextElementSibling;
        let t = -1 * nextElement.offsetWidth;
        const scrollLeft = nextElement.scrollLeft;
        if (scrollLeft === 0) {
          t = nextElement.scrollWidth + t;
        }
      } else if (event.target.classList.contains("Collection__grid-button-right")) {
        nextElement = event.target.previousElementSibling;
        let t = nextElement.offsetWidth;
        const scrollLeft = nextElement.scrollLeft;
        if (t + scrollLeft > nextElement.scrollWidth - nextElement.offsetWidth + 1) {
          t = -1 * scrollLeft;
        }
      }
      nextElement?.scrollBy({
        top: 0,
        left: t,
        behavior: "smooth"
      });
    });
  });

  //Ajaxinate Init
  const endlessCollection = new Ajaxinate({
    container: '#product-grid',
    pagination: '.infinite_next',
    loadingText: 'Loading more...',
    callback: () => {
      if(window.innerWidth > 768){
        let hoverImages = document.querySelectorAll('.media__secondary_image');
        for (let i = 0; i < hoverImages.length; ++i) {
          hoverImages[i].classList.remove('hidden');
        }
      }

      setTimeout(() => {
        if(!viewOnModelButton?.classList.contains('active')) return;
        const gridItemsWithHiddenOnModelImages = document.querySelectorAll('li.grid__item:has(.on_model_images:not(.on_model_images_show))');
        gridItemsWithHiddenOnModelImages.forEach((gridItem) => {
          const onModelImages = gridItem.querySelector('.on_model_images');
          onModelImages && onModelImages.classList.add('on_model_images_show');
          const plpImage = gridItem.querySelector('.plp_image');
          plpImage && plpImage.classList.add('plp_images_hide');
        });
      }, 100);

      setTimeout(() => {
        if (viewInEditorialButton?.classList.contains('active')) {
          const editorialItems = document.querySelectorAll('li.grid__item:has(.in_editorial_images)');
          editorialItems.forEach((gridItem) => {
            gridItem.querySelector('.in_editorial_images')?.classList.add('in_editorial_images_show');
            gridItem.querySelector('.plp_image')?.classList.add('plp_images_hide');
          });
        }
      }, 100);
      
    }
  });
})();